module.exports = __webpack_public_path__ + "static/img/logo.9e9e1f40.png";